import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/multi-repos/proz-next/src/app/learn/_heroSection.tsx");
